var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPieChartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4976 9.82271C19.5137 9.59633 19.5317 9.37195 19.5317 9.14356C19.5317 6.79987 18.6007 4.55216 16.9434 2.89492C15.2862 1.23767 13.0385 0.306641 10.6948 0.306641C10.4664 0.306641 10.242 0.324671 10.0156 0.340698V9.82271H19.4976Z",
    fill: "#4F6E90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65577 11.1832V1.70117C6.4376 1.87078 4.36523 2.87152 2.85311 4.50325C1.34099 6.13497 0.500592 8.27739 0.5 10.502C0.5 10.7324 0.51803 10.9568 0.534058 11.1832C0.696096 13.2833 1.60381 15.2563 3.09324 16.7457C4.58267 18.2351 6.55564 19.1429 8.65577 19.3049C8.88215 19.3209 9.10653 19.339 9.33692 19.339C11.5616 19.3384 13.704 18.498 15.3357 16.9858C16.9674 15.4737 17.9682 13.4014 18.1378 11.1832H8.65577Z",
    fill: "#4F6E90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChartIcon);
export default __webpack_public_path__ + "static/media/pie-chart-icon.d7f47f82735fb0b0d7c886d588dca300.svg";
export { ForwardRef as ReactComponent };